import { render, staticRenderFns } from "./thaicuisine.vue?vue&type=template&id=6bd32544&scoped=true"
import script from "./thaicuisine.vue?vue&type=script&lang=js"
export * from "./thaicuisine.vue?vue&type=script&lang=js"
import style0 from "./thaicuisine.vue?vue&type=style&index=0&id=6bd32544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd32544",
  null
  
)

export default component.exports